const SET_PRICE_SOURCE = "settings/SET_PRICE_SOURCE";
const SET_SETTINGS = "settings/SET_SETTINGS";

export const version = 4;

export const initialState = {
  priceSources: ["cardkingdom", "tcgplayer", "face2face"],
  saltLevel: 1,
  version,
};

const settings = (state = initialState, action) => {
  switch (action.type) {
    case SET_PRICE_SOURCE:
      return {
        ...state,
        priceSources: [
          ...state.priceSources.slice(0, action.i),
          action.priceSource,
          ...state.priceSources.slice(action.i + 1),
        ],
      };
    case SET_SETTINGS:
      return {
        ...state,
        ...action.settings,
      };
    default:
      return state;
  }
};

export const initRegion = () => async (dispatch, getState) => {
  const res = await fetch("/api/geo");
  const json = await res.json();
  const priceSourcesOld = getState().settings.priceSources;
  const priceSources =
    json["country-code"] === "CA" ? ["face2face", priceSourcesOld[0], priceSourcesOld[1]] : priceSourcesOld;
  dispatch({ settings: { priceSources, region: json["country-code"] }, type: SET_SETTINGS });
};

export const setSettings = (settings) => ({ settings, type: SET_SETTINGS });

export const setPriceSource = ({ i, priceSource }) => ({
  i,
  priceSource,
  type: SET_PRICE_SOURCE,
});
export default settings;
